import {connect} from 'react-redux';
import {AnyAction} from 'redux';
import {ThunkDispatch} from 'redux-thunk';

import NavigationProp from '../../../navigators/NavigationProp';

import New, {
  DispatchProps,
  StateProps,
} from '../../../components/writer/user_cancellations/New';

import AppState from '../../../reducers/AppState';

import showCurrentUserStatus from '../../../actions/writer/current_user_status/show';
import destroyWriterCurrentUserRegistration, {
  Params as WriterCurrentUserRegistrationDestroyParams,
} from '../../../actions/writer/users/registration/destroy';

import selectEntity from '../../../helpers/selectEntity';

interface Props {
  navigation: NavigationProp;
}

const mapStateToProps = (state: AppState, props: Props): any => {
  const {navigation} = props;
  const {entities, writerCurrentUserId} = state;
  const currentUser = writerCurrentUserId
    ? selectEntity(entities.writer.currentUsers, writerCurrentUserId)
    : null;
  return {
    currentUser,
    navigation,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<AppState, void, AnyAction>,
) => {
  return {
    showCurrentUserStatus: () => dispatch(showCurrentUserStatus()),
    destroyWriterCurrentUserRegistration: (
      params: WriterCurrentUserRegistrationDestroyParams,
    ) => dispatch(destroyWriterCurrentUserRegistration(params)),
  };
};

export default connect<StateProps, DispatchProps, Props, AppState>(
  mapStateToProps,
  mapDispatchToProps,
)(New);
